import './App.css';
import Login from './pages/Login/Login';
import Register from './pages/Register';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Cookies from "js-cookie";

import ProtectedRoute from "./pages/ProtectedRoute";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!Cookies.get("accessToken"));

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAuthenticated(!!Cookies.get("accessToken"));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={isAuthenticated ? <Navigate to="/homepage" /> : <Login />} />
          <Route path="/*" element={<ProtectedRoute />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
